 
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { BrowserRouter, Routes, Route, NavLink } from 'react-router-dom';
import Header from '../inc/header';
import Footer from '../inc/footer';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import { Modal, Button } from "react-bootstrap";
import { Link } from 'react-router-dom';
import 'animate.css';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import OwlCarousel from 'react-owl-carousel';
import { color, motion } from "framer-motion";
import ReCAPTCHA from "react-google-recaptcha";
import CountUp from "react-countup";
function Index() {
    const [activeId, setActiveId] = useState(null);
    const [radiusprojects, setRadiusprojects] = useState([]);
    const [carouselKey, setCarouselKey] = useState(0);
    const [activeIndex, setActiveIndex] = useState(null);
   
       useEffect(() => {
           const fetchWebsiteProjects = async () => {
               try {
                   const response = await fetch(
                       "https://crmradius.gemsdrive.co.uk/public/api/get_projects"
                   );
   
                   if (!response.ok) throw new Error("API error");
   
                   const result = await response.json();
                   setRadiusprojects(result.category || []);
               } catch (error) {
                   console.error(error);
               }
           };
   
           fetchWebsiteProjects();
       }, []);
       console.log("Projects Data:", radiusprojects);
         useEffect(() => {
               if (radiusprojects.length) {
                   setCarouselKey(prev => prev + 1);
               }
           }, [radiusprojects]);
       
           useEffect(() => {
               if (radiusprojects.length) {
                   setTimeout(() => {
                       if (window.$ && window.$(".owl-carousel").length) {
                           window.$(".owl-carousel").trigger("refresh.owl.carousel");
                       }
                   }, 300);
               }
           }, [radiusprojects]);
       
           const refreshOwl = () => {
               setTimeout(() => {
                   if (window.$ && window.$(".owl-carousel").length) {
                       window.$(".owl-carousel").trigger("refresh.owl.carousel");
                   }
               }, 300);
           };
           const [activeIndexModal, setActiveIndexModal] = useState(-1);
           const openProject = (project, index) => {
               const imagesArray = project.multiple_images
                   ? project.multiple_images.split(",")
                   : [];
       
               setActiveProject({
                   id: project.id, // ✅ keep ID
                   title: project.project_name,
                   img: `https://crmradius.gemsdrive.co.uk/main_image/${project.main_img}`,
                   multiple_img: imagesArray.map(
                       img => `https://crmradius.gemsdrive.co.uk/main_image/${img}`
                   ),
                   short_description: project.short_description ?? "",
                   description: project.description ?? "",
                   details: project.short_description ?? "",
                   client: project.client ?? "N/A",
                   date: project.date ?? "N/A",
                   skills: project.skills ? project.skills.split(",") : [],
                   projectUrl: project.project_url ?? "#",
               });
       
               setActiveIndexModal(index);   // ✅ STORE INDEX
               setShowModal(true);
           };
       
       
           const goToPrevious = () => {
               if (activeIndexModal > 0) {
                   openProject(radiusprojects[activeIndexModal - 1], activeIndexModal - 1);
               }
           };
       
           const goToNext = () => {
               if (activeIndexModal < radiusprojects.length - 1) {
                   openProject(radiusprojects[activeIndexModal + 1], activeIndexModal + 1);
               }
           };
             const [showModal, setShowModal] = useState(false);
               const [activeProject, setActiveProject] = useState(null);
               const carouselOptions = {
                   items: 4,
                   margin: 20,
                   loop: true,
                   autoplay: true,
                   autoplayTimeout: 3000,
                   dots: true,
                   nav: false,
                   responsive: {
                       0: { items: 1 },
                       768: { items: 2 },
                       992: { items: 3 },
                       992: { items: 4 },
                   },
               };
       
    return (
        <>
            <style type="text/css">
                {`
             
                `}
            </style>

            <div className="body">
                <Helmet>
                    <title>Radius Exhibition Fixtures &#8211; Interior Fit Out Company in Dubai, UAE | Signage Company - Projects</title>
                    <meta name="description" content="Radius Exhibition Fixtures &#8211; Interior Fit Out Company in Dubai, UAE | Signage Company" />
                    <meta property="og:title" content="Radius - Projects" />
                    <meta property="og:description" content="Radius Exhibition Fixtures &#8211; Interior Fit Out Company in Dubai, UAE | Signage Company" />
                </Helmet>

                <Header />

                {/* === PAGE HEADER SECTION === */}
                <div role="main" className="main">
                    <section
                        className="page-header page-header-modern page-header-background page-header-background-md overlay overlay-color-dark overlay-show overlay-op-7"
                        // style={{
                        //     backgroundImage: "url('/assets/img/slides/page-header-services.jpg')",
                        // }}
                    >
                        <div className="container">
                            <div className="row mt-5">
                                <div className="col-md-12 align-self-center p-static order-2 text-center">
                                    <h1 className="text-10">
                                        <strong>Projects</strong>
                                    </h1>
                                </div>
                                <div className="col-md-12 align-self-center order-1">
                                    <ul className="breadcrumb breadcrumb-light d-block text-center">

                                    </ul>
                                </div>
                            </div>
                        </div>
                    </section>

                    <div className="container py-4">
                        <div className="row pb-5 mb-5">
                            {radiusprojects.map((project) => (
                                <div
                                    key={project.id}
                                    className="col-lg-3 col-md-6 col-sm-12 mb-4"
                                >
                                    <NavLink to={`/project-details/${project.slug}`} 
                                        className="portfolio-item"
                                        // onClick={() => openProject(project)}
                                        style={{ cursor: "pointer" }}
                                    >
                                        <span className="thumb-info thumb-info-lighten">
                                            <span className="thumb-info-wrapper">
                                                <img
                                                    src={`https://crmradius.gemsdrive.co.uk/main_image/${project.main_img}`}
                                                    className="img-fluid w-100 border-radius-0"
                                                    alt={project.project_name}
                                                />
                                           

                                                <span className="thumb-info-title">
                                                    <span className="thumb-info-inner">
                                                        {project.project_name}
                                                    </span>
                                                    <span className="thumb-info-type">
                                                        {project.service_name}
                                                    </span>
                                                </span>

                                                <span className="thumb-info-action">
                                                    <span className="thumb-info-action-icon bg-dark opacity-8">
                                                        <i className="fas fa-plus"></i>
                                                    </span>
                                                </span>
                                            </span>
                                        </span>
                                    </NavLink>
                                </div>
                            ))}
                        </div>
                        

                    </div>
 
                </div>


                <Footer />
                 {/* === MODAL === */}
                            <Modal
                                show={showModal}
                                onHide={() => setShowModal(false)}
                                size="xl"
                                centered
                            >
                                {activeProject && (
                                    <div className="ajax-container p-4">
                                        <div className="row align-items-center py-3">
                                            <div className="col text-start">
                                               
                                            </div>
                                            <div className="col text-center">
                                                <h2 className="text-dark fw-bold mb-0">{activeProject.title}</h2>
                                            </div>
                                            <div className="col text-end">
                                                
                                            </div>
                                        </div>
                
                                        <div className="row pb-4 mb-2">
                                            <div className="col-sm-6">
                
                                                
                                                <OwlCarousel
                                                    className="owl-carousel owl-theme mb-0"
                                                    loop
                                                    margin={10}
                                                    items={1}
                                                    autoplay
                                                    autoplayTimeout={4000}
                                                    autoplayHoverPause
                                                    nav={false}
                                                    
                                                >
                                                    {activeProject.multiple_img?.map((image, index) => (
                                                        <a key={index} href={image} target='_blank' className="item">
                                                            <img
                                                                src={image}
                                                                className="img-fluid border-radius-0"
                                                                alt={`Slide ${index}`}
                                                            />
                                                        </a>
                                                    ))}
                                                </OwlCarousel>
                
                                                <strong className="text-uppercase text-dark">Share</strong>
                                                <ul className="social-icons list-inline mt-2">
                                                    <li className="list-inline-item">
                                                        <a href="http://facebook.com" target="_blank" rel="noreferrer">
                                                            <i className="fab fa-facebook-f"></i>
                                                        </a>
                                                    </li>
                                                    <li className="list-inline-item">
                                                        <a href="http://x.com" target="_blank" rel="noreferrer">
                                                            <i className="fab fa-x-twitter"></i>
                                                        </a>
                                                    </li>
                                                    <li className="list-inline-item">
                                                        <a href="http://linkedin.com" target="_blank" rel="noreferrer">
                                                            <i className="fab fa-linkedin-in"></i>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                
                                            <div className="col-sm-6">
                                                <h4 className="text-dark fw-normal mb-2">
                                                    Project <strong className="fw-bold">Description</strong>
                                                </h4>
                                                <p>{activeProject.details}</p>
                
                                                <h4 className="text-dark fw-normal mt-4 mb-2">
                                                    Project <strong className="fw-bold">Details</strong>
                                                </h4>
                                                <div dangerouslySetInnerHTML={{ __html: activeProject.description }} />
                                                {/* <ul className="list-unstyled">
                                                    <li>
                                                        <strong>Date:</strong> {activeProject.date}
                                                    </li>
                                                     
                                                    <li>
                                                        <strong>Project URL:</strong>{" "}
                                                        <a
                                                            href={activeProject.projectUrl}
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            {activeProject.projectUrl}
                                                        </a>
                                                    </li>
                                                </ul> */}
                                            </div>
                                        </div>
                
                                        <div className="text-center mt-3">
                                            <Button variant="secondary" onClick={() => setShowModal(false)}>
                                                Close
                                            </Button>
                                        </div>
                                    </div>
                                )}
                            </Modal>
            </div>
        </>
    );
}

export default Index;
